import { render } from "./AddReferenceItemModal.vue?vue&type=template&id=5eeb170a&scoped=true"
import script from "./AddReferenceItemModal.vue?vue&type=script&lang=js"
export * from "./AddReferenceItemModal.vue?vue&type=script&lang=js"

import "./AddReferenceItemModal.vue?vue&type=style&index=0&id=5eeb170a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eeb170a"]])

export default __exports__